import styled, { css } from 'styled-components';

enum L_COLORS {
    PRIMARY = '#000000',
    OUTLINE = '#FFFFFF',
    BORDER = '#A6A6A6',
}

interface IStyleProps {
    btnType: 'PRIMARY' | 'OUTLINE',
    storeIcon: 'AppStore' | 'GooglePlay' | 'AppGallery' | 'RuStore',
    width: string | number,
    height: string | number,
    textPath: string,
}

export const StoreIcon = styled.div<Partial<IStyleProps>>`
    ${({ storeIcon }) => storeIcon !== 'AppGallery' && css`
        width: 23px;
        height: 26px;
        margin-right: 8px;
    `}
`;

export const StoreText = styled.div<Partial<IStyleProps>>`
    ${({ storeIcon }) => storeIcon === 'AppGallery' && css`
        width: 95px;
        height: 26px;
    `};

    ${({ storeIcon }) => storeIcon === 'AppStore' && css`
        width: 78px;
        height: 26px;
    `};

    ${({ storeIcon }) => storeIcon === 'GooglePlay' && css`
        width: 85px;
        height: 26px;
    `};
    ${({ storeIcon }) => storeIcon === 'RuStore' && css`
        width: 85px;
        height: 26px;
    `};
    background-color: ${({ btnType }) => btnType === 'PRIMARY' ? L_COLORS.OUTLINE : L_COLORS.PRIMARY};
    mask-image: url(${({ textPath }) => textPath});
    mask-size: contain;
    mask-position: center;
    mask-repeat: no-repeat;
`;

export const StoreContent = styled.div<Partial<IStyleProps>>`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    width: ${({ width }) => width ? typeof width === 'number' ? `${width}px` : width : 'auto'};
    height: ${({ height }) => height ? typeof height === 'number' ? `${height}px` : height : 'auto'};
`;

export const BtnWrapper = styled.a<Partial<IStyleProps>>`
    padding: 6px 9px;
    border: 1px solid ${L_COLORS.BORDER};
    border-radius: 6px;
    background-color: ${({ btnType }) => btnType === 'PRIMARY' ? L_COLORS.PRIMARY : L_COLORS.OUTLINE};
    transition: opacity .25s;

    @media (hover: hover) {
        &:hover {
            opacity: 0.5;
        }
    }
`;
